import combineReducers from 'redux/lib/combineReducers';

import businessAdmin from './businessAdmin';

export default combineReducers({
  businessAdmin,
});
